import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { observer } from 'mobx-react';
import { UploadPartFilePublic } from './UploadPartFilePublic';
import { PageHeader } from 'components/PageHeader';
import { useQueryParameters } from '@partsbadger/utils';
import RedirectPreservingUTMQuery from '../../common/RedirectPreservingUTMQuery';

const { Title } = Typography;

const StartRapidQuote = observer(() => {
    const [quoteToken, setQuoteToken] = useState(localStorage.getItem('quote_token'));
    const searchParams = useQueryParameters();
    const quoteTokenParams = searchParams.get('quote_token');

    useEffect(() => {
        if (quoteTokenParams) {
            setQuoteToken(quoteTokenParams);
            window.localStorage.setItem('quote_token', quoteTokenParams);
        }
    }, []);

    return quoteTokenParams || quoteToken ? (
        <RedirectPreservingUTMQuery to={`/rapid-quote/`} />
    ) : (
        <>
            <PageHeader>
                <div className="d-flex justify-content-between align-items-baseline">
                    <Title level={1} className="mb-0">
                        Start Quote
                    </Title>
                </div>
            </PageHeader>
            <div className="container">
                <UploadPartFilePublic />
            </div>
        </>
    );
});

export default StartRapidQuote;
